import fetchRequest from '@/api/api';
import httpClient from '@/api/api';
import type { BaseApiResponse, BaseApiResult } from '@/interfaces/service/api.interface';
import type { AppUserStoreResponse, OrganizationNameChange } from '@/interfaces/service/api.interface';
import type { AppUser } from '@/interfaces/service/appuser.interface';
import { checkHttpRequestResult } from '@/utils/api.util';
import { getToken } from '@/utils/auth.util';
import { setUserInfoInClient } from '@/utils/user.util';

export const getCurrentUserInfo = async (): Promise<AppUser | string> => {
  try {
    const res: BaseApiResponse<AppUser> = await fetchRequest({
      endpoint: '/api/v1/app-users/me',
      method: 'GET'
    });
    const result = checkHttpRequestResult(res);
    if (result.isSuccess) {
      const currentUserInfo = result.data;

      setUserInfoInClient(currentUserInfo);

      return currentUserInfo;
    } else {
      return '회원 정보를 확인하지 못했습니다.';
    }
  } catch (error) {
    return '회원 정보를 확인하지 못했습니다.';
  }
};

/**
 * 회원의 조직 정보, 관심병원, 팀 정보를 가져옵니다.
 */
export const getUserStores = async (): Promise<BaseApiResult<AppUserStoreResponse>> => {
  try {
    const res: BaseApiResponse<AppUserStoreResponse> = await fetchRequest({
      endpoint: '/api/v1/users/me/stores',
      method: 'GET'
    });
    return checkHttpRequestResult(res);
  } catch (error) {
    return {
      isSuccess: false,
      status: '500',
      message: '조직 정보를 불러오는데 실패했습니다.'
    };
  }
};
